import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function StatisticButton({
  label, value, onClick, className,
}) {
  return (
    <Button
      variant={null}
      className={`w-100 px-4 py-2 rounded-4 fw-light text-start border-0 ${className}`}
      onClick={onClick}
    >
      <small className="text-gray">
        {label}
      </small>
      <div className="fs-1">
        {value === null ? <LoadingPlaceholder /> : value}
      </div>
    </Button>
  );
}

StatisticButton.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

StatisticButton.defaultProps = {
  value: null,
  className: '',
};
